
/*
  Silver Gardens Mini Collection V2
  Embedded inside native Stiletto product page.
  Keeps Stiletto's actual variant selects, product media and all other blocks intact.
  Uses established _SG Pair/_SG Role cart grouping contract.
*/
(() => {
  'use strict';
  class SGMiniNative extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try {this.config=JSON.parse(this.querySelector('[data-sgmc-config]').textContent);}
      catch(e){this.notify('Collection options could not load. Please refresh the page.');return;}
      this.variants=(this.config.variants||[]).map(v=>({...v,count:Number((String(v.name).match(/\b(3|5|10|20)\b/)||[])[1]||0)}));
      this.varieties=(this.config.varieties||[]).map(x=>String(x).trim()).filter(Boolean);
      this.count=Number(this.variants.find(v=>String(v.id)===String(this.config.variantId))?.count||3);
      const landing=new URLSearchParams(window.location.search);
      const landingPot=landing.get('sg_pot');
      const landingColour=landing.get('sg_colour');
      this.mix='assorted';this.pot=(landingPot==='luma'&&this.config.pots?.[(landingColour||'White').toLowerCase()])?'luma':'nursery';this.colour=(landingColour==='Black'?'Black':'White');this.includedPot=this.pot;this.includedColour=this.colour;this.counts=[];
      this.mixConfirmed=false;
      this.adding=false;this.resetCounts();
      this.querySelectorAll('[data-sgmc-size]').forEach(button=>button.addEventListener('click',()=>{
        this.count=Number(button.dataset.sgmcSize);
        this.resetCounts();this.syncNativeVariant();this.render();
      }));
      this.querySelectorAll('[data-sgmc-mix]').forEach(button=>button.addEventListener('click',()=>{
        this.mix=button.dataset.sgmcMix;
        this.mixConfirmed=false;
        this.render();
      }));
      this.querySelectorAll('[data-sgmc-pot]').forEach(button=>button.addEventListener('click',()=>{
        this.pot=button.dataset.sgmcPot;this.render();
      }));
      this.querySelectorAll('[data-sgmc-colour]').forEach(button=>button.addEventListener('click',()=>{
        this.colour=button.dataset.sgmcColour;this.pot='luma';this.render();
      }));
      this.querySelector('[data-sgmc-confirm-mix]')?.addEventListener('click',()=>{
        if(this.mix==='custom'&&this.customValid()){
          this.mixConfirmed=true;
          this.render();
        }
      });
      this.querySelector('[data-sgmc-add]')?.addEventListener('click',()=>this.add());
      // Theme customizer and older Stiletto native select changes are both handled.
      this.closest('.product')?.addEventListener('change',event=>{
        const input=event.target;
        if(!(input instanceof HTMLSelectElement)||!input.matches('select[name^="options["]'))return;
        const variant=this.variants.find(v=>v.name===input.value);
        if(variant && variant.count!==this.count){
          this.count=variant.count;this.resetCounts();this.render();
        }
      });
      this.render();
    }
    variant(){return this.variants.find(v=>v.count===this.count)||null;}
    linkedPot(){return this.config.pots?.[this.colour.toLowerCase()]||null;}
    resetCounts(){
      this.mixConfirmed=false;
      this.counts=this.varieties.map(()=>0);
      for(let i=0;i<this.count&&this.counts.length;i++)this.counts[i%this.counts.length]++;
    }
    totalSelected(){return this.counts.reduce((a,b)=>a+b,0);}
    customValid(){return this.varieties.length>0&&this.totalSelected()===this.count&&this.counts.every(x=>Number.isInteger(x)&&x>=0);}
    isValid(){
      const v=this.variant();const pot=this.linkedPot();
      return Boolean(v&&v.available&&(this.mix!=='custom'||(this.customValid()&&this.mixConfirmed))&&(this.pot==='nursery'||(pot&&pot.available&&pot.id)));
    }
    price(cents){
      const amount=Number(cents||0)/100;
      const locale=Number.isInteger(amount)?{maximumFractionDigits:0}:{minimumFractionDigits:2,maximumFractionDigits:2};
      return 'Dhs. '+amount.toLocaleString('en-AE',locale);
    }
    notify(message,success=false){
      const el=this.querySelector('[data-sgmc-message]');
      if(!el)return;
      el.textContent=message||'';el.hidden=!message;el.dataset.success=String(success);
    }
    syncNativeVariant(){
      const v=this.variant();if(!v)return;
      const scope=this.closest('.product')||this.closest('.shopify-section');
      const selectors=[...(scope?.querySelectorAll('.product__variants-wrapper select[name^="options["]')||[])];
      const select=selectors.find(el=>[...el.options].some(o=>o.value===v.name));
      if(select && select.value!==v.name){
        const parent=select.closest('[data-product-option]')||select.parentElement;
        const button=[...(parent?.querySelectorAll('[data-option-value]')||[])].find(b=>b.dataset.optionValue===v.name);
        if(button){button.click();}
        else{select.value=v.name;select.dispatchEvent(new Event('input',{bubbles:true}));select.dispatchEvent(new Event('change',{bubbles:true}));}
      }
      const url=new URL(window.location.href);
      if(url.searchParams.get('variant')!==String(v.id)&&history.replaceState){
        url.searchParams.set('variant',v.id);
        history.replaceState(history.state,'',url.toString());
      }
    }
    drawVarieties(){
      const holder=this.querySelector('[data-sgmc-custom]');const list=this.querySelector('[data-sgmc-varieties]');
      if(!holder||!list)return;
      holder.hidden=this.mix!=='custom';
      list.replaceChildren();
      this.varieties.forEach((name,index)=>{
        const row=document.createElement('div');row.className='sgmc-embedded__variety';
        const title=document.createElement('span');title.textContent=name;
        const controls=document.createElement('span');controls.className='sgmc-embedded__controls';
        const decrease=document.createElement('button');decrease.type='button';decrease.textContent='−';decrease.setAttribute('aria-label','Remove one '+name);
        decrease.disabled=this.counts[index]===0;
        decrease.addEventListener('click',()=>{this.counts[index]--;this.mixConfirmed=false;this.render();});
        const value=document.createElement('output');value.textContent=this.counts[index];
        const increase=document.createElement('button');increase.type='button';increase.textContent='+';
        increase.setAttribute('aria-label','Add one '+name);increase.disabled=this.totalSelected()>=this.count;
        increase.addEventListener('click',()=>{this.counts[index]++;this.mixConfirmed=false;this.render();});
        controls.append(decrease,value,increase);row.append(title,controls);list.append(row);
      });
      const total=this.querySelector('[data-sgmc-variety-total]');
      if(total){total.dataset.valid=String(this.customValid());total.textContent=this.totalSelected()+' / '+this.count+' plants selected';}
      const confirm=this.querySelector('[data-sgmc-confirm-mix]');
      if(confirm){
        confirm.disabled=!this.customValid();
        confirm.setAttribute('aria-pressed',String(this.mixConfirmed));
        confirm.textContent=this.mixConfirmed?'✓ Mix Confirmed':this.config.confirmText;
      }
      const helper=this.querySelector('[data-sgmc-custom-help]');
      if(helper && this.mixConfirmed)helper.textContent='Your custom selection is confirmed.';
      else if(helper)helper.textContent=this.config.suggestionText;
    }
    render(){
      const v=this.variant();const pot=this.linkedPot();
      this.querySelectorAll('[data-sgmc-size]').forEach(b=>{
        const n=Number(b.dataset.sgmcSize);
        b.setAttribute('aria-pressed',String(n===this.count));
        b.disabled=!this.variants.some(x=>x.count===n&&x.available);
      });
      this.querySelectorAll('[data-sgmc-mix]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sgmcMix===this.mix)));
      this.drawVarieties();
      this.querySelectorAll('[data-sgmc-pot]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sgmcPot===this.pot)));
      this.querySelectorAll('[data-sgmc-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.sgmcColour===this.colour)));
      const photo=this.querySelector('[data-sgmc-luma-image]');
      if(photo&&pot?.image){photo.src=pot.image;photo.alt='Luma Mini '+this.colour;}
      const more=this.pot==='luma'&&pot?Number(pot.price)*this.count:0;
      // Both the crossed-out price and savings use only the selected
      // Shopify variant's native compare-at price. No external benchmarks.
      const regularComparison=Number(v?.compare||0)>Number(v?.price||0)?Number(v.compare):0;
      const saving=regularComparison?regularComparison-Number(v.price):0;
      const badge=this.querySelector('[data-sgmc-offer]');
      if(badge){
        badge.hidden=!(saving>0);
        badge.textContent=saving>0?'Save '+this.price(saving):'';
        badge.removeAttribute('title');
      }
      const price=this.querySelector('[data-sgmc-price]');
      if(price)price.textContent=v?this.price(Number(v.price)+more):'Unavailable';
      const oldPrice=this.querySelector('[data-sgmc-before]');
      if(oldPrice){
        oldPrice.hidden=!(saving>0);
        oldPrice.textContent=saving>0?this.price(regularComparison+more):'';
        oldPrice.setAttribute('aria-label','Regular price');
        oldPrice.removeAttribute('title');
      }
      const refPot=this.includedPot==='luma'?this.config.pots?.[this.includedColour.toLowerCase()]:null;
      const includedPotTotal=refPot?Number(refPot.price)*this.count:0;
      const nurseryLabel=this.querySelector('[data-sgmc-nursery-pot-price]');
      if(nurseryLabel)nurseryLabel.textContent=includedPotTotal?'− '+this.price(includedPotTotal):'Included';
      const label=this.querySelector('[data-sgmc-pot-price]');
      if(label){
        if(!pot)label.textContent='Sold out';
        else{
          const difference=Math.round(Number(pot.price)*this.count-includedPotTotal);
          label.textContent=difference===0?'Included':(difference>0?'+ ':'− ')+this.price(Math.abs(difference));
        }
      }
      const unitLabel=this.querySelector('[data-sgmc-pot-units]');
      if(unitLabel)unitLabel.textContent=this.count===1?'for 1 pot':'for '+this.count+' pots';
      const breakdown=this.querySelector('[data-sgmc-breakdown]');
      if(breakdown){
        if(v&&this.pot==='luma'){breakdown.hidden=false;breakdown.textContent='Plants '+this.price(v.price)+' + '+this.count+' pots '+this.price(more);}
        else breakdown.hidden=true;
      }
      const summary=this.querySelector('[data-sgmc-summary]');
      if(summary)summary.textContent=this.count+' plants · '+(this.mix==='assorted'?'Assorted Mix':'Custom Mix')+' · '+(this.pot==='nursery'?'Nursery Pots Included':this.count+' × Luma Mini '+this.colour);
      const total=this.querySelector('[data-sgmc-summary-total]');
      if(total)total.textContent=v?this.price(Number(v.price)+more):'Unavailable';
      const button=this.querySelector('[data-sgmc-add]');
      if(button){
        button.disabled=this.adding||!this.isValid();
        button.textContent=this.adding?'Adding…':this.isValid()?this.config.buttonText:(this.mix==='custom'&&this.customValid()&&!this.mixConfirmed?'Confirm Your Mix Above':'Configuration Unavailable');
      }
    }
    async add(){
      if(this.adding||!this.isValid())return;
      const variant=this.variant();
      const pair='SG-MINI-'+Date.now().toString(36).toUpperCase()+'-'+Math.random().toString(36).slice(2,8).toUpperCase();
      const properties={
        'Collection Size':this.count+' Plants',
        'Plant Mix':this.mix==='assorted'?'Assorted Mix':'Custom Mix',
        'Pot Selection':this.pot==='nursery'?'Nursery Pot':'Luma Mini '+this.colour,
        '_SG Pair':pair,'_SG Role':'plant',
        '_SG Mini Pack Size':String(this.count)
      };
      if(this.mix==='custom')this.varieties.forEach((name,i)=>{if(this.counts[i]>0)properties[name]=this.counts[i]+' plants';});
      const items=[{id:Number(variant.id),quantity:1,properties}];
      if(this.pot==='luma'){
        const linked=this.linkedPot();
        items.push({id:Number(linked.id),quantity:this.count,properties:{
          '_SG Pair':pair,'_SG Role':'pot','_SG Mini Pack Units':String(this.count),
          'For Plant':this.config.productTitle,'Repotting':'Included',
          'Saucer':'Included'
        }});
      }
      this.adding=true;this.notify('');this.render();
      try{
        const root=(window.Shopify?.routes?.root)||'/';
        const res=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const data=await res.json();
        if(!res.ok)throw new Error(data.description||data.message||'Unable to add the collection.');
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart',{detail:{productId:this.config.productId,items:data.items||items}}));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        this.notify('Your collection has been added to your bag.',true);
      }catch(e){this.notify(e.message||'Unable to add the collection. Please try again.');}
      finally{this.adding=false;this.render();}
    }
  }
  if(!customElements.get('sg-mini-native'))customElements.define('sg-mini-native',SGMiniNative);
})();
